// extracted by mini-css-extract-plugin
module.exports = {"root":"Manager_root__3pBdn","loginForm":"Manager_loginForm__W4fqG","eventGen":"Manager_eventGen__2k6da","address":"Manager_address___DJCc"};